import React from "react";
import ServerSelect from "./ServerSelect";
import PeriodFilters from "./PeriodFilters";
import GroupByToggle from "../GroupByToggle";
import RestaurantGroupSelect from "../RestaurantGroupSelect";

export default function DashboardFilters({
  servers,
  selectedServer,
  onServerChange,
  fromDate,
  toDate,
  onFromChange,
  onToChange,
  onRefresh,
  maxDays = 31,
  quickRange,
  onQuickRangeChange,
  showGroupBy = false,
  groupByRestaurant = false,
  onGroupByChange,
  restaurantGroups = [],
  selectedRestaurantGroup = "",
  onRestaurantGroupChange,
  groupDataPending = false,
  disabled = false,
  loading = false,
  serverSelectId = "serverSelect",
}) {
  return (
    <>
      <ServerSelect
        servers={servers}
        value={selectedServer}
        onChange={onServerChange}
        id={serverSelectId}
        disabled={disabled}
      />
      {showGroupBy && (
        <GroupByToggle
          className="mb-3"
          value={groupByRestaurant}
          onChange={onGroupByChange}
          disabled={!selectedServer || disabled}
        />
      )}
      {showGroupBy && groupByRestaurant && restaurantGroups.length > 0 && (
        <RestaurantGroupSelect
          className="mb-3"
          groups={restaurantGroups}
          value={selectedRestaurantGroup}
          onChange={onRestaurantGroupChange}
          disabled={!selectedServer || disabled}
        />
      )}
      {showGroupBy && groupDataPending && (
        <p className="small text-body-secondary mb-3">
          Нет данных по группам за выбранный период.
        </p>
      )}
      <PeriodFilters
        fromDate={fromDate}
        toDate={toDate}
        onFromChange={onFromChange}
        onToChange={onToChange}
        onRefresh={onRefresh}
        maxDays={maxDays}
        quickRange={quickRange}
        onQuickRangeChange={onQuickRangeChange}
        disabled={disabled}
        loading={loading}
      />
    </>
  );
}
